function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-3 -19)",
  fill: "#43C979",
  fillRule: "evenodd"
}, React.createElement("rect", {
  x: 3,
  y: 20,
  width: 35,
  height: 6,
  rx: 1
}), React.createElement("path", {
  stroke: "#43C979",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M45.5 26L41 20h9z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 7"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/collapsable-text.6ec82cc4.svg";
export { SvgComponent as ReactComponent };